<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadBigs(1,null, true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('major_category_name')" v-model="bigFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationBigButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addBig">{{ $t('add_big') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('counselor_affiliation')" v-model="bigSearchParams.big" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="bigSearchParams.isActive" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadBigs(1,null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="bigDataContainer" :title="$t('big')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-consultation-big-list
        :bigs="bigs"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-consultation-big-list>

      <template slot="footer">
        <paginate
          :total="bigPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadBigs"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Big from '@/models/Big'
import SharedUserConfigurationConsultationBigList from '@/views/Shared/Configuration/Consultation/Bigs/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Consultation.Bigs',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationConsultationBigList
  },
  data () {
    return {
      bigsEdit: {},
      bigs: {},
      bigPages: 1,
      bigFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      bigFormErrors: {},
      itemPerPage: null,
      bigSearchParams: {
        big: typeof this.$route.query.big !== 'undefined' ? this.$route.query.big : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadBigs(this.initialPage, null, false, true)
  },
  methods: {
    async loadBigs (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#bigDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({ query: { ...this.bigSearchParams, page, itemPerPage } })
      }
      const response = await Big.all({ ...this.bigSearchParams, page, itemPerPage })
      this.bigs = response.data.data.bigs
      this.bigPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#bigDataContainer > .con-vs-loading')
    },
    async addBig (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationBigButton', scale: 0.45})
      if (this.bigFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_big_error_message'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Big.save(this.bigFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadBigs(1, this.itemPerPage)
        this.bigFormData = {
          name: '',
          is_active: '',
          id: ''
        }
        this.bigFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationBigButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.bigs[key].is_active === 1) {
          this.bigs[key].is_active = 0
        } else {
          this.bigs[key].is_active = 1
        }
        await Big.update(this.bigs[key])
        this.bigs[key].bigFormErrors = {}
      } catch (e) {
        this.bigs[key].bigFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.bigs[key].edit = true
      const editElem = this.bigs[key]
      const editObj = {
        name: editElem.name
      }
      this.bigsEdit[key] = editObj
    },
    async cancel (key) {
      this.bigs[key].name = this.bigsEdit[key].name
      this.bigs[key].edit = false
      this.bigs[key].bigFormErrors = {}
      delete this.bigsEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('big_update_confirmation_title'),
          text: this.$t('big_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationBigButton${id}`, scale: 0.45})
          await Big.update(this.bigs[key])
          this.bigs[key].edit = false
          this.bigs[key].bigFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationBigButton${id} > .con-vs-loading`)
        }
      } catch (e) {
        this.bigs[key].bigFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationBigButton${id} > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Big.delete(id)
        this.loadBigs(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationBigButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
